import { addLocaleData } from 'react-intl';
import fr from 'react-intl/locale-data/fr';
import navLocaleData from '@99designs/common/apps/global-nav/locale-data/fr';
import { setTranslations as setNavTranslations } from '@99designs/common/apps/global-nav/locale-data';

setNavTranslations(navLocaleData);
addLocaleData(fr);



// WEBPACK FOOTER //
// ./src/js/locale-data/fr.js